export default __webpack_public_path__ + "static/media/11.27374563.jpeg";